import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{on:{"click":_vm.toggleIsShownMenu}},[_c(VIcon,{staticClass:"mr-2"},[_vm._v("mdi-menu")]),_vm._v(" Menu ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }